<template>
  <div>
    <BaseCard>
      <div class="px-4 sm:px-6 border-b">
        <nav class="-mb-px flex space-x-8" aria-label="Tabs">
          <button
            v-for="facebookPage in facebookPages"
            :key="facebookPage.id"
            class="whitespace-nowrap flex py-3 px-1 border-b-2 font-medium text-sm"
            :class="[
              currentFacebookPage && facebookPage.id === currentFacebookPage.id
                ? 'border-indigo-500 text-indigo-600 cursor-default'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200',
            ]"
          >
            {{ facebookPage.name }}
          </button>
        </nav>
      </div>
      <BaseCardBody clear-padding class="overflow-hidden">
        <FacebookPageInstagramPostList
          v-if="currentFacebookPage"
          :facebook-page="currentFacebookPage"
          :account-id="accountId"
          :since="since"
          :until="until"
        />
      </BaseCardBody>
    </BaseCard>
  </div>
</template>

<script>
import { accountFacebookPagesClient } from '@/api/clients';
import FacebookPageInstagramPostList from './FacebookPageInstagramPostList.vue';

export default {
  components: {
    FacebookPageInstagramPostList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      facebookPages: [],
      currentFacebookPage: null,
    };
  },
  created() {
    this.fetchAccountFacebookPages();
  },
  methods: {
    fetchAccountFacebookPages() {
      accountFacebookPagesClient.list(this.accountId).then((response) => {
        this.facebookPages = response.data;
        const [firstFacebookPage = null] = this.facebookPages;
        this.currentFacebookPage = firstFacebookPage;
      });
    },
  },
};
</script>
